import angular from 'angular';

import './frontpage.style.scss';

import FrontpageController from './frontpage.controller';
import Routes from './frontpage.routes';

export default angular.module('autoboard.frontpage', [])
  .config(Routes)
  .controller('FrontpageController', FrontpageController)
  .name;
